// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressNz_v-icon_3RhoV","nsAddressForm":"NsAddressNz_nsAddressForm_28L82","dualColumn":"NsAddressNz_dualColumn_4aIhQ","firstCol":"NsAddressNz_firstCol_3c9VP"};